<template>
  <section class="address">
    <Header class="address__sip">
      <template v-slot:title>Домофон</template>
    </Header>
    <BackButton router-page-name="Intercom" class="address__back">
      Назад к адресам
    </BackButton>
    <Header class="address__header" type="h3" spaced>
      <template v-slot:title>{{ address.address }}</template>
      <template v-slot:addons v-if="address && address.ip">
        <div class="address__addons">
          <icon-base icon-name="server" :label="address.ip" />
          <Chips :chips="address.chips" />
          <span v-if="address.checkedAt" class="address__checked-at">
            Проверено: {{ address.checkedAt }}
          </span>
        </div>
      </template>
    </Header>
    <!-- <Header class="address__subheader" type="h4">
      <template v-slot:title>
        Пользователи
        <template v-if="address.count">({{ address.count }})</template>
      </template>
    </Header> -->
    <div class="address__tabs">
      <Tabs v-model="activeTab" :tabs="tabs" />
    </div>
    <div class="address__content">
      <component :is="activeTab" />
    </div>
  </section>
</template>

<script>
import Header from '../../components/Header.vue'
import IconBase from '../../components/Icons/IconBase.vue'
import Chips from '../../components/Chips.vue'
import BackButton from '../../components/BackButton.vue'
import Tabs from '../../components/Tabs.vue'
import AddressList from './AddressList.vue'
import PanelList from './PanelList.vue'
import ServiceData from 'Mixins/ServiceData.js'

export default {
  name: 'Address',
  mixins: [ServiceData],
  components: {
    Header,
    Tabs,
    AddressList,
    PanelList,
    Chips,
    BackButton,
    IconBase,
  },
  data() {
    return {
      activeTab: 'AddressList',
    }
  },
  computed: {
    currentId() {
      return this.$route.params.intercomId
    },
    currentOrganizationId() {
      return this.$store.getters.currentOrganizationId
    },
    currentAddress() {
      return this.$store.getters['currentAddress']
    },
    currentServer() {
      return this.$store.getters['currentServer']
    },
    serverHealth() {
      if (!this.currentServer) return null
      return this.serverHealthChecks[this.currentServer.suid] || null
    },
    address() {
      const health = this.serverHealth
      const chips = []

      if (health) {
        chips.push(
          health.is_online
            ? {
                id: 'srvrwrks',
                type: 'completed',
                icon: 'check',
                label: 'Сервер работает',
              }
            : {
                id: 'srvrwrks',
                type: 'failed',
                icon: 'cross',
                label: 'Сервер не работает',
              }
        )
      }

      return {
        address: this.currentAddress,
        ip: this.currentServer ? this.currentServer.host : null,
        chips,
        checkedAt:
          health && health.last_health_check_at
            ? this.$moment(health.last_health_check_at).format(
                'DD.MM.YYYY HH:mm'
              )
            : null,
      }
    },
    contactListTotal() {
      return this.$store.getters['contactsMeta'].total
    },
    panelListTotal() {
      return this.$store.getters['panelsMeta'].total
    },
    // environment() {
    //   return this.$store.getters.environment
    // },
    tabs() {
      const userTab = {
        id: 'AddressList',
        label: 'Пользователи',
        count: this.contactListTotal,
      }
      const panelTab = {
        id: 'PanelList',
        label: 'Панели',
        count: this.panelListTotal,
      }

      return [userTab, panelTab]

      // if (this.environment === 'production') {
      //   if (
      //     this.currentOrganizationId === 'c27d2e39-55ea-4dfb-9aa0-0a62446f7a66'
      //   ) {
      //     return [userTab, panelTab]
      //   }
      //   return [userTab]
      // }
      //
      // if (this.environment === 'development') {
      //   return [userTab, panelTab]
      // }
      //
      // return [userTab]
    },
  },
  async created() {
    await this.intercomService
      .getIntercom(this.currentId)
      .then(response => {
        if (response.data) {
          this.$store.dispatch('setCurrentIntercom', response.data)
        }
      })
      .catch(error => {
        console.log(error)
      })

    if (this.currentServer && this.currentServer.suid) {
      this.getServerHealthCheck(this.currentServer.suid)
    }

    await Promise.all([
      await this.getContacts({
        order: 'unit_name',
        order_type: 'asc',
        organizationId: this.currentOrganizationId,
        sipServerContactConfigId: this.currentId,
      }),
      await this.getPanels(this.currentId, {
        order: 'name',
        order_type: 'asc',
        organization_id: this.currentOrganizationId,
      }),
    ]).catch(error => {
      console.log(error)
    })
  },
}
</script>

<style lang="scss" scoped>
.address {
  width: 100%;

  &__sip {
    margin: 0 $space-lg $space-xl $space-lg;
  }

  &__tabs {
    margin: 0 $space-lg $space-lg $space-lg;
  }

  &__content {
    margin: 0px;
  }

  &__header {
    margin: 0 $space-lg $space-xl $space-lg;
  }

  &__back {
    margin: 0 $space-lg $space-xxs $space-lg;
  }

  &__addons {
    display: flex;
    align-items: center;
    gap: $space-xxs;
  }

  &__checked-at {
    color: $color-grey;
    font-size: $font-size-md;
    line-height: $line-height-s;
  }
}
</style>
